// extracted by mini-css-extract-plugin
export default {"star_item_container":"star-item_star_item_container__UeW4i","star_icon":"star-item_star_icon__1Dk7D","star_icon_fill":"star-item_star_icon_fill__omfxW"};